import { createApiRequest } from "../common";
import { GetOrgRequestContent, GetOrgResponseContent } from '@equaliq/api-model';

export const getOrgApi = async (request: GetOrgRequestContent): Promise<GetOrgResponseContent> => {
  const apiRequest = createApiRequest<GetOrgResponseContent>('post', '/orgs/get');
  return apiRequest(request);
};
